
<div class="modal-header">
  <h5 class="modal-title">Appointment</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onNoClick()"></button>
</div>

<div class="modal-body">
  <div class="p-2">

    <form [formGroup]="eventForm">

      <div class="row">
        <div class="title">Case Reference</div>
        <div class="value">{{event.caseRef}}</div>
      </div>

      <div class="row">
        <div class="title">Clients Name</div>
        <div class="value">{{event.client}}</div>
      </div>

      <div class="row">
        <div class="title">Clients Postcode</div>
        <div class="value">{{event.clientPostcode}}</div>
      </div>

      <!--div class="row">
        <div class="title">Appointment Date</div>
        <div class="value">{{event.appointmentDate | date:'dd/MM/yyyy'}}</div>
      </div-->

      <div class="row">
        <div class="title">Consultant</div>
        <div class="value">{{event.consultantName}}</div>
      </div>

      <div class="row">
        <div class="title">Distance from Client</div>
        <div class="value">{{event.distanceToClient}}</div>
      </div>

      <!--div class="row">
        <div class="title">Appointment Created Date</div>
        < <div class="value">{{event.appointmentCreatedDate | date:'dd/MM/yyyy HH:MM'}}</div> >
      </div-->

      <div class="row">
        <div class="title">Appointment Created By</div>
        <div class="value">{{event.appointmentCreatedUser}}</div>
      </div>

    </form>

</div>

